import { useWallet } from 'components/WalletContext';
import { BigNumber } from 'ethers';
import { useQuery } from 'react-query';
import { ERC20Token } from 'utils/types';

import { useTokenContract } from './useTokenContract';

const useERC20TokenBalance = (token: ERC20Token, networkId?: number): BigNumber | undefined => {
  const { address, network } = useWallet();
  const contract = useTokenContract(token.address, networkId);

  const { data: balance } = useQuery(
    ['balanceOf', token.address, address],
    async () => {
      console.log('Fetching balance', address);
      const balance = await contract!.balanceOf(address);
      console.log('Got balance: ', balance);
      return balance;
    },
    {
      enabled: Boolean(contract) && Boolean(address) && Boolean(network === networkId),
      refetchOnWindowFocus: false,
    }
  );

  return balance;
};

export default useERC20TokenBalance;
